import axios from "axios";
import * as qs from 'qs';

class DocumentService {
    execute(query) {
        return axios.post('app/documents.php', qs.stringify(query));
    }
}

export default new DocumentService();